import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BrowserFeedbackPage } from './browser-feedback.page';

const routes: Routes = [
  {
    path: '',
    component: BrowserFeedbackPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BrowserFeedbackPageRoutingModule {}
